<template>
<v-row>
  <v-col cols="12" md="8">
    <v-text-field label="* Descricao"
                  dense
                  :rules="[
                      this.$validators.string.required,
                          v => this.$validators.string.greaterThanOrEquals(v, 1),
                          v => this.$validators.string.lessThanOrEquals(v, 150)

                  ]"
                  v-model.trim="value.descricao"/>
  </v-col>
  <v-col cols="12" md="4">
    <lookup-dominio label="Status"
      :disabled="isNovoCadastro"
      v-model="value.status"
      :type="lookups.status"
      :hidden-clear="false"/>
  </v-col>
</v-row>
</template>

<script>
import {ItemDeDominio} from "../../../api/itemsDominio";
import LookupDominio from "../common/LookupDominio";

export default {
  name: "EventoForm",
  components: {LookupDominio},  
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      lookups: {
        status: ItemDeDominio.STATUS_PADRAO,
      },
    }
  },
  computed: {
    isNovoCadastro(){
      return !(this.value && 
             this.value.id !== null && 
             this.value.id !== undefined &&
             parseInt(this.value.id) > 0);
    },
  },
  mounted() {
    if (this.isNovoCadastro){
      this.value.status = 'A';
    }
  }
}
</script>

<style scoped>

</style>